import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=1460c76d"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
import style0 from "./Layout.vue?vue&type=style&index=0&id=1460c76d&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1460c76d')) {
      api.createRecord('1460c76d', component.options)
    } else {
      api.reload('1460c76d', component.options)
    }
    module.hot.accept("./Layout.vue?vue&type=template&id=1460c76d", function () {
      api.rerender('1460c76d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/layout/Layout.vue"
export default component.exports